export function isCryptoAvailable() {
  return typeof window !== "undefined" && window.crypto;
}
